<template>
  <div>
    <PageSubHeader />
    <ErrorPrompt />
    <router-view></router-view>
  </div>
</template>

<script>
import PageSubHeader from './components/Common/PageSubHeader';
import ErrorPrompt from './components/Common/ErrorPrompt';

export default {
  name: 'App',
  components: {
    PageSubHeader,
    ErrorPrompt
  }
}
</script>